class PickMixCart {
  constructor() {
    document.addEventListener('click', this.onDeleteClick.bind(this));
    document.addEventListener('click', this.onEditClick.bind(this));
  }

  // Removes the whole bundle: individual items cannot be removed by the customer
  onDeleteClick(event) {
    const button = event.target.closest('[data-pick-mix-group-remove]');
    if (!button) return;

    const group = button.closest('[data-pick-mix-cart-group]');
    const itemKeys = JSON.parse(group.dataset.pickMixItemKeys);

    group.setAttribute('data-pick-mix-loading', '');

    const updates = {};
    itemKeys.forEach(itemKey => {
      updates[itemKey] = 0;
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    })
      .then(response => response.json())
      .then(() => this.refreshCart())
      .catch(error => console.error('[pick-mix-cart] delete error:', error))
      .finally(() => group.removeAttribute('data-pick-mix-loading'));
  }

  // Preloads the bundle as the selection on the Pick & Mix page and navigates there.
  // The bundle stays in the cart; pick-mix.js replaces it once the customer confirms.
  onEditClick(event) {
    const button = event.target.closest('[data-pick-mix-edit]');
    if (!button) return;

    const group = button.closest('[data-pick-mix-cart-group]');
    const pickMixPath = group.dataset.pickMixPath;
    if (!pickMixPath) return;

    const variantIds = JSON.parse(group.dataset.pickMixVariantIds);
    const itemKeys = JSON.parse(group.dataset.pickMixItemKeys);

    try {
      sessionStorage.setItem(`pick-mix-selections:${pickMixPath}`, JSON.stringify({
        selectedVariantIds: variantIds,
      }));
      sessionStorage.setItem(`pick-mix-editing:${pickMixPath}`, JSON.stringify({
        groupId: group.dataset.pickMixCartGroup,
        itemKeys,
      }));
    }
    catch (error) {
      console.error('[pick-mix-cart] sessionStorage error:', error);
    }

    window.location.href = pickMixPath;
  }

  refreshCart() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.renderCartDrawer();
      return;
    }
    window.location.reload();
  }
}

new PickMixCart();
